<template>
    <div class="list-block accordion-list">
        <f7-list>
            <slot v-for="item in items">

                <f7-list-item v-if="item.link" :link="item.link" @click="onClick(item)"
                              :title="item.label" link-view="#main-view" link-close-panel
                              :class="item.disable === true ? 'disabled' : ''">
                </f7-list-item>

                <li v-else class="accordion-item">
                    <f7-link href="#" class="item-link item-content">
                        <div class="item-inner">
                            <div class="item-title">{{ item.label }}</div>
                        </div>
                    </f7-link>
                    <div class="accordion-item-content">
                        <f7-block>
                            <f7-list>
                                <slot v-for="subitem in item.items">
                                    <f7-list-item :link="subitem.link"
                                                  :title="subitem.label" link-view="#main-view" link-close-panel
                                                  :class="subitem.disable === true ? 'disabled' : ''"></f7-list-item>
                                </slot>
                            </f7-list>
                        </f7-block>
                    </div>
                </li>

            </slot>
        </f7-list>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {

            }
        },
        props: {
            items: Array,
        },
        computed: {

        },
        methods: {
            onClick: function (item) {
                if (typeof item.onClick === "function")
                    item.onClick();
            }
        },
        created: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// VSidebar.vue?d629e722